export const API_URL = process.env.VUE_APP_BASE_API_URL;
export const URL_LOGO_BRAND =
  "https://simhpnas.inspektorat.bnpb.go.id/backend/logo-bnpb.png";
